import { IImage } from "@faire/web-api/indigofair/data/IImage";
import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization";
import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";
import isChromatic from "chromatic/isChromatic";
import { useMemo } from "react";

const VARIANTS = (
  strictLocalize: StrictLocalizeFunction
): Array<{
  backgroundColor: string;
  responsiveImage: ResponsiveValues<IImage>;
  name: string;
  location: string;
  variantId: string;
}> => [
  {
    variantId: "top_header_banner_ab_fits",
    backgroundColor: "#595604",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c9861e66ce1674b3e79289c73ac230eeb7ba319bb83ea36438fedbb554694752.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/4d46c47ec3445e6ef64ca80928ad097dc7660fa4ebbc948be79ad4df3f1b68d3.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/9693b72e7fb0d90d0fe6dbeb0dc27ad0ecf34522c7606a0b7b3e4b025c64f598.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/8d901714d5585625b7bff13cff16ec48c8841f0eb4880b867a31f6219e15d22e.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/0531ddbee3356e1d540c850ccffe629baf97ca90bd161c42bf49dd2a19984292.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Howard Gee, Founder of AB Fits",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/f250bdd03aa1a067b881f8e6b0cec55b26892f2141161393ac993eecc5c81043.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "San Francisco, California",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/f250bdd03aa1a067b881f8e6b0cec55b26892f2141161393ac993eecc5c81043.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_festival_collective",
    backgroundColor: "#5B2A25",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/90789092c0638bb68f512c1cc0b0547535392807068c749e20aaab79b6ca3881.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/0157bd84149bc07a0b1dba7303b8db7c0ee21c98ddf739bac6fcd26a669fe89a.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/8a4e7e5bee219e1398295206ea5e4e847bdd9a4becff00438e438f32b1601001.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/967c59f7cb84e57c24eb9a9217da9a44e9c4e26396cb963942cd9d537b52aa62.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/3fbd32d901d1db43be40ff725fb778cd4c2f3d0baadb9b1a52ded8476b77f7b1.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Angela Wator, Founder of Festive Collective",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/59b7c648ccf6b568df29f77203826ee5419de606c2e9704c370a22c1f151cdf6.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "Chicago, Illinois",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/59b7c648ccf6b568df29f77203826ee5419de606c2e9704c370a22c1f151cdf6.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_post_script",
    backgroundColor: "#083114",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/ce353a151b005e7fdd9b4fd540a35ba3eb388a160b127f01daa8b5eb3d654944.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c11c84f8e24f938b16d4f45bba1743ed33868a0b057d89e37ebe196c98b7445c.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/a65367e39779bc20a9b0749e1904e836800c86da2c6028635a9ff3435f7a662d.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/18ca78ee2f31c0b68b017a218b259af2e0e00a21e1f23ea0314eba03d1e99c9e.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/e4cda4cb5ce4dc800ebc752e074be7617acb72d36b11bb5d705c01452620c618.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Chandler Tang, Founder of post.script.",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/a4c058f184b482412d2150c574dc716e159ab03aaaf22dabeebd08d7a2217aa4.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "San Francisco, California",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/a162fd94a1a7d0b3c6caa315af71add26e244b522c049540f801ff4bf4980b7a.png",
      },
    }),
  },
  {
    variantId: "top_header_banner_merci_milo",
    backgroundColor: "#083114",
    responsiveImage: {
      mobileAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/6f174ccfd78008a0bf37fe8a7af31a8bf6a430b52f6acf75eef426258816441c.jpeg",
      }),
      tabletAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/c633beb8ee71ee77b1efd45eea1c3deb41c86f8556d955dc46b3d4f8149115e7.jpeg",
      }),
      desktopAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/29f03571d6a0125c980b92a4db9b9112f9bd9877a81bea3e9573a78b70367c93.jpeg",
      }),
      xLargeAndAbove: IImage.build({
        url: "https://cdn.faire.com/fastly/fb9c0ad9f2df25cf72be31a09f31f04d48ef6aaa818eea56d12d2f4072596c04.jpeg",
      }),
      xxLargeDesktop: IImage.build({
        url: "https://cdn.faire.com/fastly/952aa13b7aa36e39a06e82f70d67d8843748e4311278844b6c0bfae359a24469.jpeg",
      }),
    },
    name: strictLocalize({
      defaultMessage: "Caroline Kim-Rodrigues, Founder of Merci Milo",
      description: {
        text: "Logged out home page top header banner brand name",
        img: "https://cdn.faire.com/fastly/dd4eaf6c3ce9819e1d22142deec150fafa7ed6e44cf4b655aa66811627ef97d0.png",
      },
    }),
    location: strictLocalize({
      defaultMessage: "Los Angeles, California and Portland, Oregon",
      description: {
        text: "Logged out home page top header banner brand location",
        img: "https://cdn.faire.com/fastly/888a798a181afe02fc32c633899cab4dfa93a0ded173eac064b9cf29591f8c90.png",
      },
    }),
  },
];

export const useGetTopHeaderBannerVariant = () => {
  const { strictLocalize } = useStrictLocalization();
  const variant = useMemo(() => {
    if (isChromatic()) {
      return VARIANTS(strictLocalize)[0];
    }
    const bannerVariants = VARIANTS(strictLocalize);
    const variantNumber = Math.floor(Math.random() * bannerVariants.length);
    return bannerVariants[variantNumber];
  }, [strictLocalize]);
  return variant;
};
